export const colors = {
  primary: '#000000',
  secondary: '#FFF'
}
